import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface StatInterface {
  stat_name: string;
  day: string | Date;
  expiration_date: string | Date;
  grouped_by: string;
  value: string;
  subgroup?: string;
}

export interface StatResponse {
  latest: StatInterface;
  last_week: StatInterface;
}

@Injectable()
export class KpiService {
  private apiEndpoint = '/rest-api/v1/admin/';

  constructor(private http: HttpClient) {}

  get = (statName, param?) => {
    let filter = '';
    if (param) {
      if (Array.isArray(param)) {
        filter = `?from=${param[0]}&to=${param[1]}`;
      } else {
        filter = `?filter=${param}`;
      }
    }
    return this.http.get<StatResponse | Array<any>>(this.apiEndpoint + `stats/${statName}/${filter}`, {
      withCredentials: true,
    });
  };
}
